/**
 * Simula fila de jobs após lançar conteúdos do plano de aula: pending → success (App faz poll a cada 2s).
 */

import { registerDemoJob } from "./demoJobHistory";

let phase = "idle";
let lastJob = null;

export function notifyDemoClassPlanJobPosted(body) {
  if (!body) {
    return;
  }
  const { filter, classId } = body;
  const course = (filter && filter.course) || {};
  phase = "pending";
  lastJob = {
    id: "demo-class-plan-job",
    status: "pending",
    name: "save_class_plan",
    title: `Turma ${classId} | Plano de aula`,
    classId,
    course: course.id,
    period: filter && filter.period,
    payload: body
  };
  registerDemoJob(lastJob);
}

export function takeDemoClassPlanJobsResponse() {
  if (phase === "idle" || !lastJob) {
    return [];
  }
  if (phase === "pending") {
    phase = "await_success";
    registerDemoJob({ ...lastJob, status: "pending" });
    return [{ ...lastJob, status: "pending" }];
  }
  if (phase === "await_success") {
    const done = { ...lastJob, status: "success" };
    registerDemoJob(done);
    phase = "idle";
    lastJob = null;
    return [done];
  }
  return [];
}
